import { useNavigate } from 'react-router-dom';

import { ContentLayout } from 'layouts/ContentLayout/ContentLayout';
import PageTitle from 'components/PageTitle';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { BreadcrumbItem } from 'components/Breadcrumb/Breadcrumb';

interface LayoutProps extends React.PropsWithChildren {
  breadcrumbs?: BreadcrumbItem[];
}

const Layout = ({ children, breadcrumbs }: LayoutProps) => {
  const navigate = useNavigate();

  const onCreate = () => navigate('/integrations/create', { replace: true });

  return (
    <ContentLayout className="overflow-hidden">
      <div className="mb-12">
        <PageTitle
          title="Integrations"
          breadcrumbs={breadcrumbs}
          className="items-center"
        >
          <GraniteButton size="large" onClick={onCreate}>
            Create new key
          </GraniteButton>
        </PageTitle>
      </div>
      <div className="flex-1 rounded-bl rounded-br bg-blue-800 p-8 lg:rounded-bl-none lg:rounded-tr">
        {children}
      </div>
    </ContentLayout>
  );
};

export default Layout;
